import type { ExpertFormData } from '../types';
import ExpertIntegrationContainer from './ExpertIntegrationContainer';
import { OneDrive } from '@/client/components/icons/individual/OneDrive';
import { useExpertsStore } from '../../expertsStore';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export default function ExpertOneDriveIntegrationForm() {
  const { t } = useTranslation();
  const { isEditingExpert: isEditing } = useExpertsStore();
  const { watch, setValue } = useFormContext<ExpertFormData>();
  const { confluenceIntegration } = watch();

  const handleIntegrationClick = () => {
    setValue('confluenceIntegration', !confluenceIntegration);
  };

  return (
    <ExpertIntegrationContainer
      isDisabled
      renderSetupButton={false}
      renderIntegrationStatus={!isEditing}
      integrationEnabled={confluenceIntegration}
      handleOnSetupButtonClick={handleIntegrationClick}
      integrationName={t('admin.aiAgent.experts.form.integrations.oneDrive.title')}
      integrationDescription={t('admin.aiAgent.experts.form.integrations.oneDrive.helpText')}
      integrationIcon={<OneDrive boxSize={8} />}
    />
  );
}
